export default __webpack_public_path__ + "static/media/Portfolio.b6a8182c.png";